import { LeftIcon } from 'components/molecules/AuthUpperNavBar/AuthUpperNavBar.styled';
import { Breadcrumb } from 'antd';
import {
    ContainerRow,
    VerticalLine,
} from 'components/molecules/EnrollmentUpperNavBar/EnrollmentUpperNavBar.styles';

export const EnrollmentUpperNavBar = () => (
    <ContainerRow>
        <LeftIcon />
        <VerticalLine />
        <Breadcrumb>
            <Breadcrumb.Item>Rekrutacja</Breadcrumb.Item>
            <Breadcrumb.Item>[kindergartenName]</Breadcrumb.Item>
            <Breadcrumb.Item>[schoolYear]</Breadcrumb.Item>
        </Breadcrumb>
    </ContainerRow>
);
